import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase/config';
import { updateStockPrices } from '../../utils/stockPriceUpdater';
import { toast } from 'react-hot-toast';
import { usePortfolio } from '../../contexts/PortfolioContext';

const UpdatePricesButton = () => {
  const [user] = useAuthState(auth);
  const [isUpdating, setIsUpdating] = useState(false);
  const { selectedPortfolio } = usePortfolio();

  const handleUpdate = async () => {
    if (!user?.email || isUpdating || !selectedPortfolio) return;

    setIsUpdating(true);
    const toastId = toast.loading('Fiyatlar güncelleniyor...');

    try {
      const result = await updateStockPrices(user.email, selectedPortfolio.id);
      toast.success(result.message, { id: toastId });
      
      // Yenileme başarılı istatistiklerini logla
      console.log('Price update results:', result.details);
      
    } catch (error) {
      console.error('Update error:', error);
      toast.error('Güncelleme sırasında hata oluştu', { id: toastId });
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <button
      onClick={handleUpdate}
      disabled={isUpdating}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium 
        ${isUpdating 
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
          : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
        }`}
    >
      <RefreshCw className={`w-4 h-4 ${isUpdating ? 'animate-spin' : ''}`} />
      {isUpdating ? 'Güncelleniyor...' : 'Fiyatları Güncelle'}
    </button>
  );
};

export default UpdatePricesButton;